<template>
  <header class="c-header">
    <router-link to="/">
      <h1 class="u-visually-hidden">Bob Pendar-Hughes</h1>
      <div class='c-header__logo'>
        <Logo />
      </div>
    </router-link>
  </header>
</template>

<script>
import Logo from '@/assets/svg/Logo.vue';

export default {
  components: { Logo },
};
</script>
